import { useQuery } from '@tanstack/react-query';
import ApiService from '../../ApiService';

const fetchData = async (campaignId: number, campaignChangeRequestId?: number) => {
    const { data } = await ApiService.getCampaignCreatives(campaignId, campaignChangeRequestId);
    return data;
};

const useCampaignCreativeListQuery = (campaignId: number, campaignChangeRequestId?: number) => {
    return useQuery({
        queryKey: ['campaignCreativeList', campaignId, campaignChangeRequestId],
        queryFn: () => fetchData(campaignId, campaignChangeRequestId),
        staleTime: Infinity,
        enabled: !!campaignId,
    });
};

export { useCampaignCreativeListQuery };
